import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import ptoRequestServices from 'src/services/apiServices/my-availability-services/pto-request-service';

const {
  GET_MY_AVAILABILITY_LOADING,
  REMOVE_PTO_REQ_REQUEST,
  REMOVE_PTO_REQ_SUCCESS,
  REMOVE_PTO_REQ_FAILURE,
  REMOVE_PTO_REQ_LOADER,
} = getMyAvailabilityConstants;

function* removePtoRequest(action: any): SagaReturnType<any> {
  try {
    yield put({ type: REMOVE_PTO_REQ_LOADER });
    const response = yield call(ptoRequestServices.removePtoRequest, action.providerId);
    if (response?.status === 200) {
      yield put({ type: REMOVE_PTO_REQ_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: REMOVE_PTO_REQ_FAILURE, payload: error });
  }
}

function* removePtoRequestSaga() {
  yield takeEvery(REMOVE_PTO_REQ_REQUEST, removePtoRequest);
}

export default removePtoRequestSaga;
